import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useGetPatientLastAppointmentSharedAVS } from '@grow-therapy-team/seedling-components';

import { useGetAuthedAtTimestamp } from '../auth/useGetAuthedAtTimestamp';
import { useGetShowSessionRecapExperimentCallback } from './useGetShowSessionRecapExperimentCallback';

/**
 * Whether the client should see their shared AVS — they have to have one
 * and be in the session recap experiment.
 */
export function useGetShouldShowPatientAVS() {
  const [authedAtTimestamp] = useGetAuthedAtTimestamp();

  const { patientShortId } = useParams();
  const { appointmentWithSharedAVS, loading: isLoading } = useGetPatientLastAppointmentSharedAVS(
    patientShortId ?? '',
    !authedAtTimestamp,
  );
  const hasAVS = !!appointmentWithSharedAVS?.patientAfterVisitSummary?.afterVisitSummary;
  const getShowSessionRecap = useGetShowSessionRecapExperimentCallback();

  const getShouldShowPatientAVS = useCallback(
    () => !isLoading && hasAVS && getShowSessionRecap(),
    [getShowSessionRecap, hasAVS, isLoading],
  );

  return { isLoading, getShouldShowPatientAVS };
}
